import { render, staticRenderFns } from "./RoomEdit.vue?vue&type=template&id=5e2a8f68&lang=pug&"
import script from "./RoomEdit.vue?vue&type=script&lang=ts&"
export * from "./RoomEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports